import React from 'react';
import SEO from '../components/SEO';
import ContactHero from '../components/contact/ContactHero';
import ContactInfo from '../components/contact/ContactInfo';
import ContactForm from '../components/contact/ContactForm';
import ContactHours from '../components/contact/ContactHours';
import ContactSocial from '../components/contact/ContactSocial';

const Contact: React.FC = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Contact"
        description="Get in touch with Bizani Media. We'd love to hear about your project — documentaries, branding, events, or documentation."
        path="/contact"
        keywords="contact Bizani Media, Harare, Avonlea, info@bizani.co.zw, get a quote, video production enquiry"
      />
      <ContactHero />
      <section className="py-20 bg-black">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
              <ContactInfo />
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
      <ContactHours />
      <ContactSocial />
    </div>
  );
};

export default Contact;
